(() => {
  if (customElements.get('article-image-width')) return;
  customElements.define('article-image-width', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.article-single');
      this.hero = this.section?.querySelector('.article__image');
      this.image = this.hero?.querySelector('img');
      if (!this.image) return;
      this.update = () => {
        const ratio = this.image.naturalWidth / this.image.naturalHeight || Number(this.image.getAttribute('width')) / Number(this.image.getAttribute('height'));
        const imageBox = this.image.getBoundingClientRect();
        const width = Math.min(this.hero.clientWidth, imageBox.width, imageBox.height * ratio);
        if (width > 0 && Number.isFinite(width)) {
          this.section.style.setProperty('--article-copy-width', `${width}px`);
          this.section.setAttribute('data-image-width-ready', '');
        }
      };
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.image);
      this.observer.observe(this.hero);
      this.image.addEventListener('load', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.image?.removeEventListener('load', this.update);
    }
  });
})();
